import { Component, OnInit } from '@angular/core';
import { ContentService } from 'src/app/shared/services/content.service';

@Component({
    selector: 'app-db-updates',
    templateUrl: './db-updates.component.html',
    styleUrls: ['./db-updates.component.scss'],
})
export class DbUpdatesComponent implements OnInit {
    dbupdates = [];
    itemCount = 4;

    get dbupdatesToShow() {
        return this.loadedAll
            ? this.dbupdates
            : this.dbupdates.slice(0, this.itemCount);
    }

    loadedAll = false;

    constructor(private contentService: ContentService) {
        this.contentService.getDBUpdates().subscribe((data) => {
            this.dbupdates = data.sort((a, b) => {
                return (
                    <any>new Date(b.updatedOn || b.creationDate) -
                    <any>new Date(a.updatedOn || a.creationDate)
                );
            });
        });
    }

    ngOnInit(): void {}

    loadAll() {
        this.itemCount = this.dbupdates.length;
    }
}
